import { atom } from 'jotai'

export type VoiceTopic = 'general' | 'workspace' | 'challenges' | 'bug' | 'feature'

export interface VoiceDialogState {
  open: boolean
  presetTopic?: VoiceTopic
}

export const voiceDialogAtom = atom<VoiceDialogState>({ open: false })
